import { Container, Card, Row, Col } from 'react-bootstrap';
import { FaFacebook, FaWhatsapp, FaKey, FaLink, FaCheckCircle, FaTools } from 'react-icons/fa';

const WhatsAppIntegrationGuide = () => {
    return (
        <div style={{ minHeight: '100vh', color: '#fff' }}>
            <Container className="p-4">
                <Row className="justify-content-center">
                    <Col lg={10}>
                        {/* Header */}
                        <div className="text-center mb-5">
                            <FaWhatsapp size={48} style={{ color: '#25D366', marginBottom: '16px' }} />
                            <h1 style={{ color: '#fff', marginBottom: '12px' }}>WhatsApp Integration Guide</h1>
                            <p style={{ color: '#ccc', fontSize: '18px' }}>
                                Follow these steps to integrate WhatsApp Business API with your chatbot
                            </p>
                        </div>

                        {/* Step 1 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ 
                                        backgroundColor: '#1a3a52', 
                                        borderRadius: '50%', 
                                        width: '40px', 
                                        height: '40px', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        marginRight: '16px'
                                    }}>
                                        <span style={{ color: '#fff', fontWeight: 'bold' }}>1</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Create Meta Business Portfolio</h5>
                                        <small style={{ color: '#ccc' }}>Set up your business account on Meta</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>Go to <a href="https://business.facebook.com/" target="_blank" rel="noopener noreferrer" style={{ color: '#17a2b8' }}>Meta Business Suite</a> to create your business portfolio or use an existing business account.</li>
                                    <li>Log in with your personal Facebook account. If you don't have an account, click <span style={{ color: '#fff', fontWeight: 'bold' }}>Create new account</span> to sign up for one.</li>
                                    <li>Click <span style={{ color: '#fff', fontWeight: 'bold' }}>Create an account</span> and enter your business details such as business portfolio name, your name, and business email.</li>
                                    <li>Click Submit or Create to create your portfolio. You'll get an email asking to confirm your business email address.</li>
                                </ol>
                                <div style={{ 
                                    backgroundColor: '#1a3a52', 
                                    padding: '12px 16px', 
                                    borderRadius: '8px', 
                                    marginTop: '16px',
                                    borderLeft: '4px solid #17a2b8'
                                }}>
                                    <small style={{ color: '#b8daff' }}>
                                        📋 For more information visit the <a href="https://www.facebook.com/business/help/1710077379203657" style={{ color: '#17a2b8' }}>Facebook Business Help Center</a>
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>

                        {/* Step 2 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ 
                                        backgroundColor: '#28a745', 
                                        borderRadius: '50%', 
                                        width: '40px', 
                                        height: '40px', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        marginRight: '16px'
                                    }}>
                                        <span style={{ color: '#fff', fontWeight: 'bold' }}>2</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Create WhatsApp Business App</h5>
                                        <small style={{ color: '#ccc' }}>Set up your app in Meta Developer Dashboard</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>Go to the <a href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer" style={{ color: '#17a2b8' }}>Meta Developer Dashboard</a> and click <strong style={{ color: '#fff' }}>Create App</strong>.</li>
                                    <li>Choose <strong style={{ color: '#fff' }}>Business</strong> as the app type and enter the required details.</li>
                                    <li>Under the app dashboard, click <strong style={{ color: '#fff' }}>Add Product</strong> and select <strong style={{ color: '#fff' }}>WhatsApp</strong>.</li>
                                    <li>Go to <strong style={{ color: '#fff' }}>API Setup</strong> and click the dropdown under step 1 to add your WhatsApp Business phone number <em style={{ color: '#ffc107' }}>(Ensure the number is not associated with any WhatsApp account)</em>.</li>
                                    <li>Copy the <strong style={{ color: '#fff' }}>Phone number ID</strong> and paste to your Quickychat app</li>
                                </ol>
                            </Card.Body>
                        </Card>

                        {/* Step 3 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ 
                                        backgroundColor: '#ffc107', 
                                        borderRadius: '50%', 
                                        width: '40px', 
                                        height: '40px', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        marginRight: '16px'
                                    }}>
                                        <span style={{ color: '#000', fontWeight: 'bold' }}>3</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Generate Permanent Token</h5>
                                        <small style={{ color: '#ccc' }}>Create system user and access token</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>To generate a system token, access the <a href='https://business.facebook.com/select/' target='_blank' style={{ color: '#17a2b8' }}>Business settings</a> panel and then click System Users</li>
                                    <li>Create a new system user in <strong style={{ color: '#fff' }}>Business Settings &gt; System Users &gt; Add</strong> and assign the <strong style={{ color: '#fff' }}>Admin</strong> role.</li>
                                    <li>Assign your app to the user by going to <strong style={{ color: '#fff' }}>Assign assets &gt; Select your app &gt; Full control</strong></li>
                                    <li>
                                        Generate a token with the following permissions:
                                        <div style={{ 
                                            backgroundColor: '#1a1a1a', 
                                            padding: '12px', 
                                            borderRadius: '8px', 
                                            marginTop: '8px',
                                            border: '1px solid #555'
                                        }}>
                                            <ul style={{ margin: 0, paddingLeft: '20px' }}>
                                                <li style={{ color: '#ffc107' }}>business_management</li>
                                                <li style={{ color: '#ffc107' }}>whatsapp_business_management</li>
                                                <li style={{ color: '#ffc107' }}>whatsapp_business_messaging</li>
                                            </ul>
                                        </div>
                                    </li>
                                    <li>Copy the permanent token and add to your Quickychat account</li>
                                </ol>
                                <div style={{ 
                                    backgroundColor: '#1a3a52', 
                                    padding: '12px 16px', 
                                    borderRadius: '8px', 
                                    marginTop: '16px',
                                    borderLeft: '4px solid #17a2b8'
                                }}>
                                    <small style={{ color: '#b8daff' }}>
                                        📋 For more information visit <a href="https://developers.facebook.com/docs/whatsapp/business-management-api/get-started#admin-system-users" target='_blank' style={{ color: '#17a2b8' }}>Facebook guide</a>
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>

                        {/* Step 4 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ 
                                        backgroundColor: '#6f42c1', 
                                        borderRadius: '50%', 
                                        width: '40px', 
                                        height: '40px', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        marginRight: '16px'
                                    }}>
                                        <span style={{ color: '#fff', fontWeight: 'bold' }}>4</span>
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Set Up Webhooks</h5>
                                        <small style={{ color: '#ccc' }}>Configure webhook URL and verification</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>From your app on <a href="https://developers.facebook.com/apps/" target="_blank" rel="noopener noreferrer" style={{ color: '#17a2b8' }}>Meta Developer Dashboard</a>, go to <strong style={{ color: '#fff' }}>configuration</strong> or click <strong style={{ color: '#fff' }}>Configure webhooks</strong></li>
                                    <li>Copy the Webhook URL and verify token from Quickychat and paste it into your webhook configuration settings</li>
                                    <li>Click <strong style={{ color: '#fff' }}>Verify and save</strong>, and then subscribe to messages.</li>
                                </ol>
                            </Card.Body>
                        </Card>

                        {/* Step 5 */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <div style={{ 
                                        backgroundColor: '#28a745', 
                                        borderRadius: '50%', 
                                        width: '40px', 
                                        height: '40px', 
                                        display: 'flex', 
                                        alignItems: 'center', 
                                        justifyContent: 'center',
                                        marginRight: '16px'
                                    }}>
                                        <FaCheckCircle size={20} style={{ color: '#fff' }} />
                                    </div>
                                    <div>
                                        <h5 style={{ color: '#fff', margin: 0 }}>Verify & Test</h5>
                                        <small style={{ color: '#ccc' }}>Complete the integration setup</small>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ol style={{ color: '#ccc', lineHeight: '1.6' }}>
                                    <li>Click <strong style={{ color: '#fff' }}>Confirm Verification</strong> from your Quickychat dashboard. It should say <span style={{ color: '#28a745', fontWeight: 'bold' }}>Webhook Verified</span></li>
                                    <li>Test by sending a WhatsApp message to your WhatsApp Business Account Number.</li>
                                </ol>
                            </Card.Body>
                        </Card>

                        {/* Troubleshooting */}
                        <Card style={{ backgroundColor: '#2d2d2d', borderColor: '#444', marginBottom: '24px' }}>
                            <Card.Header style={{ backgroundColor: '#333', borderBottom: '1px solid #444', padding: '20px' }}>
                                <div className="d-flex align-items-center">
                                    <FaTools size={24} style={{ color: '#ffc107', marginRight: '12px' }} />
                                    <h5 style={{ color: '#fff', margin: 0 }}>Troubleshooting Tips</h5>
                                </div>
                            </Card.Header>
                            <Card.Body style={{ padding: '24px' }}>
                                <ul style={{ color: '#ccc', lineHeight: '1.6', margin: 0 }}>
                                    <li>Double-check your Webhook URL and verification token if errors occur.</li>
                                    <li>Ensure the token has the correct permissions.</li>
                                    <li>Be aware of any limitations on your WhatsApp Business API plan.</li>
                                </ul>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default WhatsAppIntegrationGuide;